import React from 'react';
import { View, Text, TouchableOpacity, StyleSheet } from 'react-native';
import { Ionicons } from '@expo/vector-icons';
import AppModal from './web/AppModal';
import { isWeb } from '../utils/platformUtils';
import { webModalFooterStyle } from '../theme/webModal';
import { colors } from '../theme/colors';

interface GoalLimitModalProps {
  visible: boolean;
  onClose: () => void;
  onUpgrade: () => void;
  currentGoals: number;
  maxGoals: number;
}

const GoalLimitModal: React.FC<GoalLimitModalProps> = ({ visible, onClose, onUpgrade, currentGoals, maxGoals }) => {
  return (
    <AppModal visible={visible} onRequestClose={onClose} size="sm" scrollable={false}>
      <Ionicons
        name="alert-circle"
        size={48}
        color={colors.button.primary}
        style={{ marginBottom: 12, alignSelf: 'center' }}
      />
      <Text style={styles.title}>Goal Limit Reached</Text>
      <Text style={styles.message}>
        You currently have {currentGoals} goals, but your subscription only allows {maxGoals} goals.
      </Text>
      <View style={[styles.buttonRow, isWeb && webModalFooterStyle]}>
        <TouchableOpacity style={styles.cancelButton} onPress={onClose}>
          <Text style={styles.cancelButtonText}>Cancel</Text>
        </TouchableOpacity>
        <TouchableOpacity style={styles.upgradeButton} onPress={onUpgrade}>
          <Text style={styles.upgradeButtonText}>Upgrade</Text>
        </TouchableOpacity>
      </View>
    </AppModal>
  );
};

const styles = StyleSheet.create({
  title: {
    fontSize: 22,
    fontWeight: 'bold',
    color: colors.button.primary,
    marginBottom: 8,
    textAlign: 'center',
  },
  message: {
    fontSize: 16,
    color: '#333',
    marginBottom: 24,
    textAlign: 'center',
    lineHeight: 22,
  },
  buttonRow: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    width: '100%',
    gap: 12,
  },
  cancelButton: {
    flex: 1,
    backgroundColor: '#e0e0e0',
    paddingVertical: 12,
    borderRadius: 8,
    alignItems: 'center',
  },
  cancelButtonText: {
    color: '#333',
    fontWeight: 'bold',
    fontSize: 16,
  },
  upgradeButton: {
    flex: 1,
    backgroundColor: colors.button.primary,
    paddingVertical: 12,
    borderRadius: 8,
    alignItems: 'center',
  },
  upgradeButtonText: {
    color: colors.button.primaryText,
    fontWeight: 'bold',
    fontSize: 16,
  },
});

export default GoalLimitModal;
